import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ROUTES } from './learner.routes';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { SharedPostLoginModule } from './../shared-postlogin/shared-postlogin.module';
import { SharedAllModule } from '../shared-all/shared-all.module';

//Components
import { Learner } from './components/main/learner.component';
import { CreateUserAnalytics } from './components/create-user-analytics/create-user-analytics.component';

//Services
import { CustomTranslationLoader } from './../app/services/custom-translation-loader';
// import { PreviewService } from './services/preview.service';
import { LearnerAuthGuard } from './services/learner-auth-guard.service';
import { LtiHelperService } from 'modules/teacher/services/lti-helper.service';
import { CreateUserAnalyticsService } from './services/create-user-analytics.service';



@NgModule({
  declarations: [
    Learner,
    CreateUserAnalytics
  ],
  imports: [
    CommonModule,
    ROUTES,
    FormsModule,
    TranslateModule.forChild({
      loader: { 
        provide: TranslateLoader, 
        useClass: CustomTranslationLoader 
      }
    }),
    SharedPostLoginModule,
    SharedAllModule
  ],
  providers : [
    // PreviewService,
    LearnerAuthGuard,
    LtiHelperService,
    CreateUserAnalyticsService
  ]
  
})
export class LearnerModule {
  
}
